import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './App.css';

export default function Login(){

    const navigate = useNavigate();
    const [user, setUser] = useState([]);
    const [date,setDate] = useState([]);
    var appuser = [];
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const APP_NAME = process.env.REACT_APP_NAME;
    
    
    useEffect(()=>{
        
        fetch(API_URL+"api/User/GetUser")
        .then(response => response.json())
        .then(data =>{setUser(data)}) ;
    
        fetch(API_URL+"api/ReceiptKey/GetDate")
        .then(response => response.json())
        .then(data =>{setDate(data)})
    },[])
     
   console.log(user);
   console.log(date);
   console.log(APP_NAME);
   console.log(API_URL);
   
       

function validate()
   {
        localStorage.setItem("currentdate",date[0].CurrentDate.slice(0,10));
    
        const logindate = localStorage.getItem("currentdate");
        
        if(logindate === new Date().toISOString().slice(0,10))
        {
                 
            if(user.length !== 0)
            {
                 appuser = user.filter((cus)=>{if(cus.UserName === document.getElementById('username').value ){return(cus)}})
            
                if(appuser.length !== 0 )
                {

                    if(appuser[0].UserName === document.getElementById('username').value && appuser[0].Password === document.getElementById('password').value)
                    {

                        if(appuser[0].UserType === 1)
                        {
                            var userid = appuser[0].UserID.toString();
                            
                            localStorage.setItem("utype","1");
                            localStorage.setItem("userid",userid);
                            localStorage.setItem("username",appuser[0].UserName);
                            
                            return true;
                        }
                        else
                        {
                            var userid = appuser[0].UserID.toString();
                            localStorage.setItem("utype","2");
                            localStorage.setItem("userid",userid);
                            localStorage.setItem("username",appuser[0].UserName);

                            return true;
                        }
                    }
                    else
                    {
                        return false;        
                    }
                }
                else
                {
                    return false;
                }   
            }
        }
        else
        {
                checkdateDialog();
        }
    }

    function showOKdialog()
    {
            const dialog = document.getElementById('loginDialog');
            dialog.showModal();
    }
    function checkdateDialog()
    {
            const dialog = document.getElementById('checkdateDialog');
            dialog.showModal();
    }

    function closeOKdialog()
    {
        const dialog = document.getElementById('loginDialog');
        dialog.close();
    }
    function closecheckdatedialog()
    {
        const dialog = document.getElementById('checkdateDialog');
        dialog.close();
    }

    

    function closeMe() {
        //var win = window.open("","_self"); /* url = "" or "about:blank"; target="_self" */
        //win.close();
        // Open the new window 
        // with the URL replacing the
        // current page using the
        // _self value
        
    }
    
    return(
    <>
    
    <div style = {{height:"100%", width:"100%"}}>
    
    <div style={{width:"100%",height:"40px",paddingLeft:"10px" ,
                backgroundColor:"blue", color:"white",textAlign:"center",fontSize:"25px"}}>{APP_NAME}</div>
    
    <div style={{marginTop:"25%", marginRight:"25%",marginBottom:"25%",marginLeft:"15%" }}>
     
    <label for = "username">User Name</label><br/>
    <input id = "username" style = {{height:"30px",width:"250px"}}></input><br/><br/>
    <label for = "password">Password</label><br/>
    <input type = "password" id = "password" style = {{height:"30px",width:"250px"}}></input><br></br>
    <button type="button" style = {{height:"35px", width:"100px", marginTop:"25px"}} onClick={()=>
        {
            if(validate())
            {navigate('/home')}
            else
            {showOKdialog()}
            }} autoFocus>Login</button>

    <button type="button" style = {{height:"35px", width:"100px", marginTop:"25px",marginLeft:"10px"}} onClick={()=>{}}>Exit</button>
       
    </div>
    </div>

    <dialog id="loginDialog" style = {{borderStyle:"outset",borderRadius:"5px"}}><p>Please Enter Valid Username And Password</p>
            <button style={{marginLeft:"40%"}} onClick={()=>{closeOKdialog()}}>OK</button>
    </dialog>

    <dialog id="checkdateDialog" style = {{borderStyle:"outset",borderRadius:"5px"}}><p>Please Check Your Date</p>
            <button style={{marginLeft:"40%"}} onClick={()=>{closecheckdatedialog()}}>OK</button>
    </dialog>
    
    </>)
    
}